import { Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class GtmTrackerService {
  constructor(private router: Router) {
    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => this.trackPageViews(event));
  }

  private trackPageViews(event: NavigationEnd) {
    const pageEvent = {
      event: "page",
      pageName: event.urlAfterRedirects,
    };

    (window as any).dataLayer?.push(pageEvent);
  }
}
